import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import RankAnalytics from './components/RankAnalytics';

const RankAnalyticsPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Rank Analytics</h3>
      </Col>
    </Row>
    <Row>
      <RankAnalytics />
    </Row>
  </Container>
);

export default RankAnalyticsPage;
